import { encryptPayload } from '@standardnotes/encryption';
export class EncryptTypeAPayload {
    constructor(operators) {
        this.operators = operators;
    }
    async executeOne(payload, key, signingKeyPair) {
        return encryptPayload(payload, key, this.operators, signingKeyPair);
    }
    async executeMany(payloads, key, signingKeyPair) {
        return Promise.all(payloads.map((payload) => this.executeOne(payload, key, signingKeyPair)));
    }
}
